// extracted by mini-css-extract-plugin
export default {"title":"alamat-pembeli-properti_title__il3Jl","input-wrapper":"alamat-pembeli-properti_input-wrapper__CRYVU","info":"alamat-pembeli-properti_info__pWKBR"};